export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-08_01.048d3eba.jpg";